import { useCallback, useEffect, useState } from "react";
import { FQDNData, getFQDN } from "../remote/scan_data"
import { useNavigate } from "react-router-dom";
import { Box, Button, CircularProgress, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { AIReportData, getLatestAIReportForHost, requestAIReportForHost } from "../remote/reports";

export interface FQDNProps {
	id: string
	data?: FQDNData | undefined
	hideChildren?: boolean
}

export const FQDNSimple = ({id, data = undefined}: FQDNProps) => {
	const navigate = useNavigate()

	const [fqdnData, setFqdnData] = useState<FQDNData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getFQDN(id, (data, resp) => {
				if (data) {
					setFqdnData(data);
				} else {
					setFqdnData(null);
				}
			});
		}
	}, [setFqdnData]);

	const [reportState, setReportState] = useState<'READY' | 'GENERATING'>('READY');
	const [reportData, setReportData] = useState<AIReportData | null | undefined>(undefined);

	const checkReportStatusPing = useCallback(() => {
		getLatestAIReportForHost(id, (data, resp) => {
			if (data) {
				if (data.finished_at) {
					setReportState('READY');
				} else {
					setTimeout(checkReportStatusPing, 2000 + 1000 * Math.random())
				}

				if (data.id != reportData?.id && data.finished_at != reportData?.finished_at) {
					setReportData(data);
				}
			} else {
				setReportData(null);
			}
		})
	}, [reportData, setReportData])

	useEffect(() => {
		getLatestAIReportForHost(id, (data, resp) => {
			if (data) {
				if (data.finished_at) {
					setReportState('READY');
				} else {
					setReportState('GENERATING');
					setTimeout(checkReportStatusPing, 2000 + 1000 * Math.random());
				}
				setReportData(data);
			} else {
				setReportData(null);
			}
		})
	}, [setReportData])

	if (fqdnData) {
		return <>
		<Grid container spacing={2} alignItems={'center'}>
			<Grid size={{sm: 12, md: 12, lg: 8}}>
				<Button onClick={() => navigate(`/tree/fqdn/${id}`)} sx={{textTransform: 'none'}}>
					<Typography variant="body1" sx={{wordBreak:'break-all', overflowWrap:'break-word'}}>{fqdnData.fqdn}</Typography>
				</Button>
			</Grid>
			<Grid size={{sm: 12, md: 12, lg: 4}}>
				<Box sx={{ml:'auto'}}>{
					reportData === undefined
					? <CircularProgress/>
					: ((reportData === null && reportState != 'GENERATING')
						? <Button onClick={() => {
							setReportState('GENERATING');
							requestAIReportForHost(id, (data, resp) => {
								if (data) {
									if (data.finished_at) {
										setReportState('READY');
									} else {
										setTimeout(checkReportStatusPing, 2000 + 1000 * Math.random())
									}
									setReportData(data);
								} else {
									setReportData(null);
								}
							})
						}}>
							<Typography variant="body1">Generate report</Typography>
						</Button>
						: ((reportState == 'GENERATING')
							? <Button disabled>Generating.. <CircularProgress size='24px' /></Button>
							: (reportData != null && reportState == 'READY') ?(<Button onClick={() => navigate(`/reports/ai/fqdn/${reportData.id}`)}>
								<Typography variant="body1">View report</Typography>
							</Button>) : <Typography>Error</Typography>))
				}</Box>
			</Grid>
		</Grid></>
	} else {
		return (<CircularProgress />)
	}
}

export const FQDN = ({id, data = undefined, hideChildren = false}: FQDNProps) => {
	const navigate = useNavigate()

	const [fqdnData, setFqdnData] = useState<FQDNData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getFQDN(id, (data, resp) => {
				if (data) {
					setFqdnData(data);
				} else {
					setFqdnData(null);
				}
			});
		}
	}, [setFqdnData]);

	return (fqdnData
		? <TableContainer component={Paper}>
			<Table width={hideChildren ? 'auto' : '100%'}>
				<TableHead>
					<TableRow>
						<TableCell>
							<Typography variant="h5">FQDN</Typography>
						</TableCell>
						<TableCell align='right'>
							{hideChildren ? (<></>) :
							(fqdnData.children.length > 0 ?
							<Button onClick={() => navigate(`/tree/fqdn/${id}`)}>See children</Button>
							: <Button disabled>No children</Button>)}
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
				<TableRow><TableCell align='left'>FQDN</TableCell><TableCell align='right'>{fqdnData.fqdn}</TableCell></TableRow>
				<TableRow><TableCell align='left'>First seen</TableCell><TableCell align='right'>{String(fqdnData.first_seen)}</TableCell></TableRow>
				<TableRow><TableCell align='left'>Last seen</TableCell><TableCell align='right'>{String(fqdnData.last_seen)}</TableCell></TableRow>
				</TableBody>
			</Table>
			</TableContainer>
		: <CircularProgress />
	)
}
